import { User } from '@/models/permission/AuthorityModel';
import { client } from './API';
import { ENVIRONMENTAL_VARIABLES } from '@/utils/Environment';

/**
 * Subscribe to card or board
 * @param id id of CARD or BOARD to subscribe
 * @return nothing
 */
export const subscribe = ({
  communityId,
  roomId,
  boardId,
  id,
}: {
  communityId: string;
  roomId: string;
  boardId: string;
  id: string;
}): Promise<void> =>
  client
    .post(
      `${ENVIRONMENTAL_VARIABLES.API_ALFRESCO_URL}/${communityId}/rooms/${roomId}/boards/${boardId}/cards/${id}/subscriptions`,
      {},
    )
    .then((response) => response.data);

/**
 * Unsubscribe from card or board
 * @param id id of CARD or BOARD to unsubscribe
 * @return nothing
 */
export const unsubscribe = ({
  communityId,
  roomId,
  boardId,
  id,
}: {
  communityId: string;
  roomId: string;
  boardId: string;
  id: string;
}): Promise<void> =>
  client
    .delete(
      `${ENVIRONMENTAL_VARIABLES.API_ALFRESCO_URL}/${communityId}/rooms/${roomId}/boards/${boardId}/cards/${id}/subscriptions`,
    )
    .then((response) => response.data);

/**
 * @returns all subscribers (user objects) of CARD or BOARD
 */
export const fetchSubscribers = ({
  communityId,
  roomId,
  boardId,
  id,
}: {
  communityId: string;
  roomId: string;
  boardId: string;
  id: string;
}): Promise<User[]> =>
  client
    .get(
      `${ENVIRONMENTAL_VARIABLES.API_ALFRESCO_URL}/${communityId}/rooms/${roomId}/boards/${boardId}/cards/${id}/subscribers`,
    )
    .then((response) => response.data);
